
import { mapState } from 'vuex'

export default {
  components: {},

  data() {
    return {
      acceptAnalytics: true,
    }
  },

  computed: {
    ...mapState('content', ['cookieBanner']),
  },

  mounted() {
    window.addEventListener('keydown', this.handleEsc)

    // Kept from the removed FocusTrap's initial-focus, so keyboard and screen
    // reader users still land on the close button when the banner appears
    this.$refs.closeBtn?.focus({ preventScroll: true })
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEsc)
  },

  methods: {
    close() {
      this.$emit('closed')
    },
    handleEsc(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        this.$emit('closed')
      }
    },
  },
}
